import { apiRequestActions } from '@ackee/redux-utils';

import { fetchTotalTripsTypes } from './types';

export default apiRequestActions(fetchTotalTripsTypes, { isDetailRequest: true });
